import { render } from "./HCPatientMain.vue?vue&type=template&id=f846779c&ts=true"
import script from "./HCPatientMain.ts?vue&type=script&lang=ts&external"
export * from "./HCPatientMain.ts?vue&type=script&lang=ts&external"

import "./HCPatientMain.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__